import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store'
import http from '../http/index'
import conf from '../config/config'

Vue.use(Router)

let router = new Router({
    routes: [
        {
            name: '',
            path: '/',
            redirect: '/usercenter/myactivity',
            meta: {
                title: '个人中心'
            },
            component: resolve => require(['@/view/usercenter/index.vue'], resolve),
            children: [
            {
                name: 'myactivity',
                path: '/usercenter/myactivity',
                meta: {
                    title: '我的活动'
                },
                component: resolve => require(['@/view/usercenter/myactivity.vue'], resolve)
            },
            {
                name: 'myregistration',
                path: '/usercenter/myregistration/:id',
                meta: {
                    title: '我的活动-查看详情'
                },
                component: resolve => require(['@/view/usercenter/myregistration.vue'], resolve)
            },
            {
                name: 'myworksdetails',
                path: '/usercenter/myregistration/:type/:id',
                meta: {
                    title: '作品详情'
                },
                component: resolve => require(['@/view/usercenter/myworksdetails.vue'], resolve)
            }, {
                name: 'message',
                path: '/usercenter/message',
                meta: {
                    title: '消息中心'
                },
                component: resolve => require(['@/view/usercenter/message.vue'], resolve)
            }, {
                name: 'basicinfo',
                path: '/usercenter/basicinfo',
                meta: {
                    title: '基本信息'
                },
                component: resolve => require(['@/view/usercenter/basicinfo.vue'], resolve)
            }]
        },
        {
            name: 'detail',
            path: '/detail',
            meta: {
                title: '详情'
            },
            component: resolve => require(['@/view/detail.vue'], resolve)
        },
        {
            name: 'enroll',
            path: '/enroll/:id',
            meta: {
                title: '活动报名'
            },
            component: resolve => require(['@/view/enroll.vue'], resolve)
        },
        {
            name: 'publish',
            path: '/publish',
            meta: {
                title: '上传作品'
            },
            component: resolve => require(['@/view/publish/publish.vue'], resolve)
        },
        {
            name: 'shdt',
            path: '/shdt',
            meta: {
                title: '手绘地图作品申报'
            },
            component: resolve => require(['@/view/publish/shdtindex.vue'], resolve)
        },
        {
            name: 'shdt_zg',
            path: '/shdt_zg',
            meta: {
                title: '手绘地图作品申报'
            },
            component: resolve => require(['@/view/publish/shdtindex_zg.vue'], resolve)
        },
        {
            name: 'shdtPreview',
            path: '/shdtPreview',
            meta: {
                title: '手绘地图作品申报预览'
            },
            component: resolve => require(['@/view/publish/shdtPreview.vue'], resolve)
        },
        {
            name: 'copyright',
            path: '/copyright',
            meta: {
                title: '作品版权协议'
            },
            component: resolve => require(['@/view/copyright.vue'], resolve)
        },
        // 预览暂时没用
        {
            name: 'preview',
            path: '/preview/:id',
            meta: {
                title: '活动预览'
            },
            component: resolve => require(['@/view/publish/preview.vue'], resolve)
        },
        {
            name: 'brand',
            path: '/brand/:id',
            meta: {
                title: '“一地一品牌”作品申报'
            },
            component: resolve => require(['@/view/publish/brandindex.vue'], resolve)
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.name !== 'detail' && to.name !== 'preview' && to.name !== 'shdt' && to.name !== 'shdtPreview') {
        http.get('author/logined').then((res) => {
            if (res.data.status === 1) {
                if (!res.data.data.isLogin) {
                    localStorage.removeItem('userinfo')
                    localStorage.removeItem('USERNAME')
                    let url = encodeURIComponent(window.location.href)
                    window.location.href = `${conf.loginRoot}front/sso/login?referer=${url}`
                } else {
                    localStorage.setItem('USERNAME', res.data.data.userName)
                }
            }
        })
    }
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})
router.afterEach(() => {
    window.scrollTo(0, 0)
    store.commit('setMenu', router.currentRoute)
})
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js